/**
 * Parses the `hrtId` query param into a validated array of numeric strings.
 * Returns the valid IDs or `undefined` if the param is missing/malformed.
 *
 * Pure (no React / no "use client") so it can be shared by the client hook
 * (`useValidatedHrtIds`) and the schedule/review server components that
 * authoritatively validate `hrtId` from the request URL.
 */
export function parseHrtIds(
  raw: string | null | undefined,
): string[] | undefined {
  if (raw == null) return undefined;
  const ids = raw.split(",").filter(Boolean);
  if (ids.length === 0) return undefined;
  if (!ids.every((id) => /^\d+$/.test(id))) return undefined;
  return ids;
}
